import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { BaseService } from "../base.service";
import { Page } from "../commons/page";
import { ProfileRequest } from "./models/profile-request.model";
import { Profile } from "./models/profile.model";
import { ProfileType } from "./models/profilte-type.model";
import moment from 'moment';
import { NotificationService } from "../util/notification.service";

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends BaseService {
  private mobilityUrl = environment.api.mobilityUrl;

  constructor(private httpClient: HttpClient, protected notificationService: NotificationService, protected translate: TranslateService,) {
    super(notificationService, translate);
  }

  getUserProfile(mobilityAccountId: number): Observable<Profile[]> {
    return this.httpClient.get<Profile[]>(`${this.mobilityUrl}/api/mobility-account-manager/v1/mobility-accounts/${mobilityAccountId}/profiles`);
  }

  getProfileTypes(): Observable<ProfileType[]> {
    return this.httpClient.get<ProfileType[]>(`${this.mobilityUrl}/api/mobility-account-manager/v1/profile-types`);
  }

  getRequestsProfile(filters: any = {}, sortDirection: string = '', sortActive: string = '', page: number = 0, size: number = 10, fromResolver = false): Observable<Page<ProfileRequest>> {
    let params = new HttpParams()
    .set('page', page.toString())
    .set('size', size.toString());

    if (sortActive && sortDirection) {
      params = params.set('sort', sortActive + ',' + sortDirection);
      if (fromResolver) {
        params = params.append('sort', 'creationDate,desc');
      }
    }

    if (filters?.profileRequestId) {
      params = params.set('profileRequestId', filters.profileRequestId);
    }
    if (filters?.userId) {
      params = params.set('mobilityAccountId', filters.userId);
    }
    if (filters?.externalReference) {
      params = params.set('externalReference', filters.externalReference);
    }
    if (filters?.status) {
      params = params.set('status', filters.status);
    }
    if (filters?.fromStartValidityDate) {
      params = params.set('fromStartValidityDate', moment(filters.fromStartValidityDate).startOf('day').format('YYYY-MM-DD'));
    }
    if (filters?.toStartValidityDate) {
      params = params.set('toStartValidityDate', moment(filters.toStartValidityDate).endOf('day').format('YYYY-MM-DD'));
    }
    if (filters?.fromCreationDate) {
      params = params.set('fromCreationDate', moment(filters.fromCreationDate).startOf('day').toISOString().replace('Z','-0000'));
    }
    if (filters?.toCreationDate) {
      params = params.set('toCreationDate', moment(filters.toCreationDate).endOf('day').toISOString().replace('Z','-0000'));
    }
    if (filters?.renew) {
      params = params.set('renewal', filters.renew);
    }

    return this.httpClient.get<Page<ProfileRequest>>(`${environment.api.mobilityUrl}/api/data-control-manager/v1/profile-requests`, { params });
  }

  getRequestProfileByMobilityAccountIdAndById(profileRequestId: number, mobilityAccountId: number): Observable<ProfileRequest> {
    return this.httpClient.get<ProfileRequest>(`${environment.api.mobilityUrl}/api/data-control-manager/v1/mobility-accounts/${mobilityAccountId}/profile-requests/${profileRequestId}`);
  }

  updateProfileRequest(updatedProfileRequest: ProfileRequest): Observable<ProfileRequest> {
    if (!updatedProfileRequest.mobilityAccountId || !updatedProfileRequest.profileRequestId) {
      throw new Error('The profileRequestId and mobilityAccountId attributes must not be empty in the request-profile');
    }
    return this.httpClient.put<ProfileRequest>(`${environment.api.mobilityUrl}/api/data-control-manager/v1/mobility-accounts/${updatedProfileRequest.mobilityAccountId}/profile-requests/${updatedProfileRequest.profileRequestId}`, updatedProfileRequest);
  }

  validateProfileRequest(profileRequest: ProfileRequest): Observable<ProfileRequest> {
    const params = new HttpParams().set('statusReason', profileRequest.statusReason);
    return this.httpClient.post<ProfileRequest>(`${environment.api.mobilityUrl}/api/data-control-manager/v1/mobility-accounts/${profileRequest.mobilityAccountId}/profile-requests/${profileRequest.profileRequestId}/_validate`, '', { params });
  }

  refuseProfileRequest(profileRequest: ProfileRequest): Observable<ProfileRequest> {
    const params = new HttpParams().set('statusReason', profileRequest.statusReason);
    return this.httpClient.post<ProfileRequest>(`${environment.api.mobilityUrl}/api/data-control-manager/v1/mobility-accounts/${profileRequest.mobilityAccountId}/profile-requests/${profileRequest.profileRequestId}/_refuse`, '', { params });
  }
}
